import i18n, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./translation/en";
import es from "./translation/es";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const translationObj = (obj: any) => ({ translation: obj });

const resources = {
  en: translationObj(en),
  es: translationObj(es)
};

const interpolation = {
  escapeValue: false
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: 'en',
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    interpolation
  });

const mockTranslation = (translationText: { [key: string]: any } = {}) => {
  const initTranslationOptions: InitOptions = {
    fallbackLng: 'en',
    lng: 'en',
    resources: {
      en: translationObj(translationText)
    },
    interpolation
  };

  i18n.use(initReactI18next).init(initTranslationOptions);
};

export { i18n as default, mockTranslation };